import React, {Component} from 'react';
import {Mask} from 'react-weui';
import {connect} from 'react-redux';
import RewardRankList from './ClassroomRewardRank';
import DiscussList from './ClassroomDiscussList';
import qs from 'qs';
import axios from 'axios';
import { WKCommentDialog } from '../../components/wk'
import {filterDiscuss, isNewWeiXinMachine} from '../../utils';


import '../../styles/classroom/ClassroomDiscussPanel.css'


class ClassroomDiscussPanel extends Component {
    constructor (props) {
        super(props)
        this.state = {
            isShowCommentDialog: false,
        }
    }

    componentWillUnmount() {
        this.fixInputPosition && clearInterval(this.fixInputPosition);
    }

    hide() {
        this.props.dispatch({
            type: 'CLASSROOM_HIDE_DISCUSS_PANEL'
        })
    }

    selectTab(tab) {
        this.props.dispatch({
            type: 'CLASSROOM_SHOW_DISCUSS_PANEL',
            payload: tab
        })
    }

    reward(lecturer) {
        this.props.dispatch({
            type: 'CLASSROOM_SHOW_REWARD',
            payload: {
                account: lecturer.account
            }
        })
    }

    onTextSubmit(e) {
        if (e) e.preventDefault();
        this.setState({ isShowCommentDialog: false })
        const {discussList, showedNoListenDialog} = this.props
        const content = discussList.draft

        let text = () => {
            return <p><i className="iconfont icon-cuowu wk-toast-error"/><span>不能发空白消息</span></p>
        };
        if (content.trim().length === 0) {
            this.context.page.showToast(text(), '', true, 2000)
            return;
        }

        if (content.length < 1) {
            return
        }

        if (filterDiscuss(content) && !showedNoListenDialog) {
            this.refs.textInput.value = ''
            this.props.dispatch({
                type: 'DISCUSS_UPDATE_DRAFT',
                payload: ''
            })
            this.props.dispatch({type: 'CLASSROOM_SHOW_NOLISTEN_DIALOG', payload: 'listen'});
            this.props.dispatch({type: 'CLASSROOM_SHOW_SHOWED_NOLISTEN_DIALOG'});
            return;
        }

        const {lecture, account} = this.props
        const m = {
            type: 'discuss_text',
            content: content,
            account: account,
            timestamp: Date.now() * 0.001
        }

        axios.post('/api/classroom/' + lecture.id + '/discuss/send', qs.stringify(m)).then((response) => {
            if (response.data.code === 0) {
                this.refs.textInput.value = ''

                this.props.dispatch({
                    type: 'DISCUSS_UPDATE_DRAFT',
                    payload: ''
                })
                this.props.dispatch({
                    type: 'DISCUSS_SEND',
                    payload: m
                })
                this.props.dispatch({
                    type: 'DISCUSS_HIDE_WRITING'
                })
                this.props.dispatch({
                    type: 'ROBOT_SET_DISCUSS',
                    payload: m
                })
                this.hide();
            } else {
                this.context.page.showAlert(response.data.msg)
            }
        }).catch((error) => {
            this.context.page.showAlert(error.toString())
        })
    }

    onTextInputFocus() {
        this.props.dispatch({
            type: 'DISCUSS_SHOW_WRITING'
        })

        if (!isNewWeiXinMachine()) {
            this.fixInputPosition && clearInterval(this.fixInputPosition);
            this.fixInputPosition = setInterval(() => {
                document.body.scrollTop = document.body.scrollHeight;
            }, 1000);
        } else {
            this.setState({ isShowCommentDialog: true }, () => {
                this.$textarea.focus()
            })
        }
    }

    onTextInputBlur() {
        this.props.dispatch({
            type: 'DISCUSS_HIDE_WRITING'
        })
        clearInterval(this.fixInputPosition);
    }

    onTextInputChange(e) {
        this.props.dispatch({
            type: 'DISCUSS_UPDATE_DRAFT',
            payload: e.target.value
        })
    }

    render() {
        const {showDiscussPanel} = this.props
        if (!showDiscussPanel)
            return null

        const {options, discussList, stats} = this.props
        const showInput = discussList.draft || discussList.writing
        const inputAttrs = options.can_discuss ? {} : {disabled: 'disabled'}
        return <div>
            <Mask onClick={this.hide.bind(this)}/>
            <div className="reward-rank-panel">
                <div className="header">
                    <div className="navbar">
                        <div className={'nav-item ' + (showDiscussPanel === 'discuss_list' ? 'active' : '')}
                             onClick={e => this.selectTab('discuss_list')}>
                            最新评论{stats.discuss_count > 0 && "(" + stats.discuss_count + ")"}
                        </div>
                        <div className={'nav-item ' + (showDiscussPanel === 'reward_rank' ? 'active' : '')}
                             onClick={e => this.selectTab('reward_rank')}>
                            赞赏排行
                        </div>
                    </div>
                    <span className="close" onClick={this.hide.bind(this)}>
						<i className="iconfont icon-cuowu"></i>
					</span>
                </div>
                <div className="body">
                    {showDiscussPanel === 'discuss_list' &&
                    <DiscussList />
                    }
                    {showDiscussPanel === 'reward_rank' &&
                    <RewardRankList />
                    }
                </div>

                {showDiscussPanel === 'discuss_list' &&
                <form action="" method="post" onSubmit={this.onTextSubmit.bind(this)}>
                    <div className={"discuss-list-input weui-flex " + (showInput ? "writing" : "")}>

                        <component className="text-input">
                            <input type="text"
                                   placeholder={options.can_discuss ? '发表评论' : '课堂暂时不允许评论'}
                                   ref="textInput" {...inputAttrs}
                                   value={isNewWeiXinMachine() ? '' : discussList.draft}
                                   onFocus={this.onTextInputFocus.bind(this)}
                                   onBlur={this.onTextInputBlur.bind(this)}
                                   onChange={this.onTextInputChange.bind(this)}
                                   readOnly={isNewWeiXinMachine()}
                                   onClick={this.onTextInputFocus.bind(this)}
                            />
                        </component>
                        <input type="submit" className="weui-btn weui-btn_primary text-send"
                               value="发送"/>
                    </div>
                </form>
                }
                {showDiscussPanel === 'reward_rank' &&
                <div className="footer">
                    <div className="tips">点击下面头像可以赞赏</div>
                    <div className="fixwidth">
                        <div className="rewards">
                            {this.props.lecturers.map((m) => {
                                return <div className="lecturer" key={m.account.id} onClick={e => this.reward(m)}>
                                    <div className="avatar"><img src={m.account.small_avatar_url} alt="avatar"/></div>
                                    <div className="nickname text-ellipsis">{m.account.nickname}</div>
                                </div>
                            })}
                        </div>
                    </div>
                </div>
                }
                <WKCommentDialog type="ios" title='发表评论' buttons={[
                    { label: '取消', type: 'default', onClick: e => this.setState({ isShowCommentDialog: false }) },
                    { label: '提交', onClick: e => this.onTextSubmit() }
                ]} show={this.state.isShowCommentDialog}>
                    <textarea
                        rows="4"
                        onChange={this.onTextInputChange.bind(this)}
                        value={discussList.draft}
                        ref={r => this.$textarea = r}
                    >
                    </textarea>
                </WKCommentDialog>
            </div>
        </div>
    }
}


ClassroomDiscussPanel.contextTypes = {
    page: React.PropTypes.object
};


export default connect((state) => ({
    account: state.account,
    lecture: state.classroom.lecture,
    showDiscussPanel: state.classroom.showDiscussPanel,
    lecturers: state.classroom.lecturers,
    options: state.classroom.options,
    discussList: state.discussList,
    showTopVideo: state.classroom.showTopVideo,
    stats: state.classroom.stats,
    showedNoListenDialog: state.classroom.showedNoListenDialog,
}))(ClassroomDiscussPanel)





// WEBPACK FOOTER //
// ./src/components/classroom/ClassroomDiscussPanel.js